<div mat-dialog-header>
  @if (data.bulkAction === 'inProcess') {
    <h1>
      Are you sure you'd like to mark the selected records as "in process"?
      <span class="record-count">
        {{ data.recordCount | number }} Records Selected
      </span>
      <span class="process-warning">
        Updates involving more than 1,000 records may take several minutes to
        complete.
      </span>
    </h1>
  } @else if (data.bulkAction === 'initiateCase') {
    <h1>
      Are you sure you'd like to initiate a case?
      <span class="record-count">
        {{ data.recordCount | number }} Records Selected
      </span>
      <span class="process-warning">
        Updates involving more than 1,000 records may take several minutes to
        complete.
      </span>
    </h1>
  } @else if (data.bulk) {
    <h1>
      Are you sure you'd like to
      {{ data.bulkAction === 'addNote' ? 'add a note to' : data.bulkAction }}
      the selected records?
      <span class="record-count">
        {{ data.recordCount | number }} Records Selected
      </span>
      <span class="process-warning">
        Updates involving more than 1,000 records may take several minutes to
        complete.
      </span>
    </h1>
  } @else {
    <h1>
      Notes & Attachments <span> - {{ data.tradeId }}</span>
    </h1>
  }
</div>
<mat-dialog-content class="dialog-container row">
  @if (data.bulkAction !== 'initiateCase') {
    <div>
      <mat-form-field class="w-100">
        <mat-label>Enter Notes Here</mat-label>
        <textarea
          matInput
          [placeholder]="'Enter Notes Here'"
          [(ngModel)]="note"
        ></textarea>
      </mat-form-field>
    </div>

    @if (rights.includes('CMUploadFiles')) {
      <div class="upload-case-files mb-3">
        <h4 class="mb-2"> Upload Case Files </h4>
        <input
          #fileUpload
          type="file"
          class="file-input"
          (change)="onFileSelected($event)"
        />
        <span class="mb-2">
          {{ fileName || 'No file selected yet' }}
        </span>
        @if (!fileName) {
          <button
            type="button"
            class="w-100"
            mat-stroked-button
            aria-label="Attach File"
            color="primary"
            (click)="fileUpload.click()"
          >
            <mat-icon>attach_file</mat-icon> Attach File
          </button>
        } @else {
          <button
            type="button"
            class="w-100 mb-3"
            mat-stroked-button
            aria-label="Choose a Different File"
            (click)="fileUpload.click()"
          >
            <mat-icon>upload</mat-icon> Choose a Different File
          </button>
          <button
            type="button"
            class="w-100 mb-3"
            mat-button
            aria-label="Remove File"
            color="warn"
            (click)="clearFile()"
          >
            <mat-icon>clear</mat-icon> Remove File
          </button>
        }
      </div>
    }
  }

  @if (!data.bulk && tradeAttachments) {
    <div class="attached-files mb-2">
      <table>
        <thead>
          <tr>
            @for (col of caseFileCols; track col.label) {
              <th>{{ col.label }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (tradeAttachment of tradeAttachments; track tradeAttachment) {
            <tr>
              @for (col of caseFileCols; track col.label) {
                <td>
                  <span class="attachment-container">
                    {{ tradeAttachment[col.varName] }}
                    @if (tradeAttachment.Location && col.varName === 'Name') {
                      <button
                        type="button"
                        mat-icon-button
                        color="primary"
                        matTooltip="Download File"
                        (click)="downloadAttachment(tradeAttachment)"
                      >
                        <mat-icon>download</mat-icon>
                      </button>
                    }
                  </span>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions class="row buttons">
  <button type="button" mat-raised-button (click)="cancel()">Cancel</button>
  <button type="button" mat-raised-button color="accent" (click)="save()">
    @if (data.bulk) {
      Confirm
    } @else {
      Save
    }
  </button>
</mat-dialog-actions>
<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop: false }" />
